'use client';

import { GenericSkeleton } from '@/_components';

interface ITableBodySkeleton {
  dataTestID: string;
  rows: number;
  columns: number;
}

export const TableBodySkeleton = ({ dataTestID, rows, columns }: ITableBodySkeleton) => (
  <tbody data-testid={dataTestID}>
    {[...Array(rows)].map((_item, index) => (
      <tr key={index}>
        {[...Array(columns)].map((_item, index) => (
          <td key={index}>
            <GenericSkeleton width="w-full" height="h-5" />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);

TableBodySkeleton.displayName = 'TableBodySkeleton';
